import React from "react";
import styles from "../assets/safetyManagement.module.css";

const SafetyManagement = () => {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.titleSection}>
            <h3 className={styles.mainTitle}>
              Comprehensive Safety Management for Your Property
            </h3>
          </div>

          <div className={styles.description}>
            <p>
              At Global Guardians, we prioritize the safety and security of your
              property above all else. Our safety management solutions are
              designed to provide peace of mind to property owners and managers,
              ensuring the highest standards of protection for your assets and
              occupants.
            </p>
          </div>

          <div className={styles.whyChooseSection}>
            <h3 className={styles.categoryTitle}>
              Why Choose Global Guardians?
            </h3>

            <div className={styles.featuresRow}>
              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Expertise</h4>
                <p className={styles.featureDescription}>
                  With years of experience in property management and security,
                  we have the expertise to develop tailored safety solutions for
                  a wide range of properties.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Proactive Approach</h4>
                <p className={styles.featureDescription}>
                  We take a proactive approach to safety management, identifying
                  potential risks and implementing preventive measures to
                  mitigate them before they escalate.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>24/7 Monitoring</h4>
                <p className={styles.featureDescription}>
                  Our dedicated team provides round-the-clock monitoring and
                  response to ensure rapid intervention in case of emergencies
                  or security breaches.
                </p>
              </div>

              <div className={styles.featureCard}>
                <h4 className={styles.featureTitle}>Compliance</h4>
                <p className={styles.featureDescription}>
                  We stay up-to-date with all relevant safety regulations and
                  standards to ensure full compliance and minimize liability for
                  property owners.
                </p>
              </div>
            </div>
          </div>

          <div className={styles.servicesSection}>
            <div className={styles.titleSection}>
              <h3 className={styles.mainTitle}>Our Services</h3>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>
                Risk Assessment and Mitigation
              </h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>
                    Comprehensive Evaluation
                  </h4>
                  <p className={styles.serviceDescription}>
                    We conduct thorough risk assessments of your property to
                    identify potential hazards and vulnerabilities.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Customized Solutions</h4>
                  <p className={styles.serviceDescription}>
                    Based on our assessment, we develop customized safety plans
                    tailored to address the specific needs and risks of your
                    property.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Implementation</h4>
                  <p className={styles.serviceDescription}>
                    Our team implements a range of preventive measures,
                    including security systems, access controls, and emergency
                    procedures, to mitigate identified risks.
                  </p>
                </div>
              </div>
            </div>

            <div className={styles.serviceCategory}>
              <h3 className={styles.categoryTitle}>Emergency Response</h3>

              <div className={styles.servicesRow}>
                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Immediate Action</h4>
                  <p className={styles.serviceDescription}>
                    In the event of an emergency, our team is trained to respond
                    swiftly and effectively, minimizing damage and ensuring the
                    safety of occupants.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Coordination</h4>
                  <p className={styles.serviceDescription}>
                    We work closely with local authorities and emergency
                    services to coordinate response efforts and facilitate a
                    timely resolution to any crisis situation.
                  </p>
                </div>

                <div className={styles.serviceCard}>
                  <h4 className={styles.serviceTitle}>Communication</h4>
                  <p className={styles.serviceDescription}>
                    Clear and timely communication is paramount during
                    emergencies. We keep all stakeholders informed throughout
                    the response process to ensure transparency and
                    accountability.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.contactSection}>
            <h4 className={styles.contactTitle}>Get in Touch</h4>
            <p className={styles.contactDescription}>
              Protect your property and occupants with our comprehensive safety
              management solutions. Contact us today to learn more about how
              Global Guardians can help you safeguard your assets and minimise
              risks.
            </p>
            <p className={styles.contactEmail}>
              Contact:{" "}
              <a href="mailto:clientcare@global-guardians.co.uk">
                clientcare@global-guardians.co.uk
              </a>{" "}
              and we will be happy to discuss your requirements.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SafetyManagement;
